(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  State                                                              */
  /* ------------------------------------------------------------------ */
  var state = {
    steps: [],
    answers: {},
    currentStepIndex: 0,
    history: [],
    userName: '',
    userAge: '',
    userEmail: ''
  };

  /* ------------------------------------------------------------------ */
  /*  DOM cache                                                          */
  /* ------------------------------------------------------------------ */
  var dom = {};

  function cacheDom() {
    dom.section = document.querySelector('[js-quiz-section]');
    if (!dom.section) return false;
    dom.backBtn = dom.section.querySelector('[js-quiz-back]');
    dom.progressText = dom.section.querySelector('[js-quiz-progress-text]');
    dom.progressBar = dom.section.querySelector('[js-quiz-progress-bar]');
    dom.progressWrapper = dom.section.querySelector('[js-quiz-progress-wrapper]');
    dom.quizContent = dom.section.querySelector('.quiz-content');
    return true;
  }

  /* ------------------------------------------------------------------ */
  /*  Step builder — scans DOM and builds flat step array                */
  /* ------------------------------------------------------------------ */
  function buildSteps() {
    var stepEls = dom.section.querySelectorAll('[js-quiz-step]');
    var steps = [];

    stepEls.forEach(function (el) {
      var type = el.dataset.stepType;
      var blockId = el.dataset.blockId;
      var shopifyBlock = el.closest('.shopify-block');

      var step = {
        type: type,
        blockId: blockId,
        el: el,
        shopifyBlock: shopifyBlock,
        transitionMap: null // populated for radio questions
      };

      if (type === 'form') {
        step.inputType = el.dataset.inputType;
      }

      if (type === 'question') {
        var selType = el.dataset.selectionType;
        step.selectionType = selType;

        // For radio questions, build transition map
        if (selType === 'radio') {
          step.transitionMap = {};
          var transitions = el.querySelectorAll('[js-quiz-transition]');
          transitions.forEach(function (t) {
            var answerId = t.dataset.answerId;
            // We'll add the step index after all steps are collected
            step.transitionMap[answerId] = {
              el: t,
              stepIndex: -1
            };
          });
        }
      }

      steps.push(step);
    });

    state.steps = steps;

    steps?.forEach(function (step) {
      if(step.type === 'transition') {
        if(step.el) {
          step.el.setAttribute('data-step-index', state.steps.indexOf(step));
        }
      } else {
        if(step.shopifyBlock) {
          step.shopifyBlock.setAttribute('data-step-index', state.steps.indexOf(step));
        }
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Input type initialisation (moved from inline script)               */
  /* ------------------------------------------------------------------ */
  function initQuizAnswerInputs() {
    var answers = dom.section.querySelectorAll('[js-quiz-answer]');
    answers.forEach(function (answer) {
      var input = answer.querySelector('[js-answer-input]');
      var question = answer.closest('[js-quiz-question]');
      if (question && input) {
        var selectionType = question.dataset.selectionType;
        var questionId = question.dataset.questionId;
        input.type = selectionType === 'checkbox' ? 'checkbox' : 'radio';
        input.name = 'quiz-question-' + questionId;
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Show / hide helpers                                                */
  /* ------------------------------------------------------------------ */
  function showStep(index) {
    var step = state.steps[index];
    if (!step) return;

    // Hide all shopify-blocks
    var blocks = dom.quizContent.querySelectorAll(':scope > .shopify-block');
    blocks.forEach(function (b) {
      b.classList.remove('quiz-step--active');
    });

    // Show the correct block
    if (step.shopifyBlock) {
      step.shopifyBlock.classList.add('quiz-step--active');
    }

    state.currentStepIndex = index;
    updateProgress();
    updateBackButton();
    focusInput(step);
  }

  function focusInput(step) {
    if (step.type === 'form') {
      var input = step.el.querySelector('[js-quiz-form-input]');
      if (input) {
        setTimeout(function () { input.focus(); }, 100);
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Progress bar                                                       */
  /* ------------------------------------------------------------------ */
  function updateProgress() {
    // Count only primary steps (not transitions)
    var primarySteps = state.steps.filter(function (s) { return s.type !== 'transition'; });
    var currentPrimary = 0;
    var currentStep = state.steps[state.currentStepIndex];

    // Find position among primary steps
    for (var i = 0; i < primarySteps.length; i++) {
      if (primarySteps[i] === currentStep ||
          (currentStep.type === 'transition' && currentStep.parentQuestionStep === primarySteps[i])) {
        currentPrimary = i;
        break;
      }
    }

    var total = primarySteps.length;
    var pct = total > 1 ? Math.round(((currentPrimary) / (total - 1)) * 100) : 0;
    pct = Math.max(1, Math.min(100, pct));

    if (dom.progressText) dom.progressText.textContent = pct + '%';
    if (dom.progressBar) dom.progressBar.style.width = pct + '%';
  }

  /* ------------------------------------------------------------------ */
  /*  Back button visibility                                             */
  /* ------------------------------------------------------------------ */
  function updateBackButton() {
    var step = state.steps[state.currentStepIndex];
    var hideBack = state.history.length === 0 ||
                   step.type === 'final';

    if (dom.progressWrapper) {
      if (hideBack) {
        dom.progressWrapper.classList.add('no-back-arrow');
      } else {
        dom.progressWrapper.classList.remove('no-back-arrow');
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Navigation — forward                                               */
  /* ------------------------------------------------------------------ */
  function goForward() {
    var step = state.steps[state.currentStepIndex];
    saveAnswer(step);

    var nextIndex = findNextStep(step);
    if (nextIndex === -1 || nextIndex >= state.steps.length) return;

    if(state.history.indexOf(state.currentStepIndex) === -1) {
      state.history.push(state.currentStepIndex);
    }
    showStep(nextIndex);
  }

  function findNextStep(step) {
    return findNextPrimaryStep(state.currentStepIndex);
  }

  function findNextPrimaryStep(fromIndex) {
    for (var i = fromIndex + 1; i < state.steps.length; i++) {
      return i;
    }
    return -1;
  }

  /* ------------------------------------------------------------------ */
  /*  Navigation — from transition to next primary                       */
  /* ------------------------------------------------------------------ */
  function goForwardFromTransition() {
    dom.section.querySelectorAll('[js-quiz-transition]').forEach(function (t) {
        t.classList.remove('quiz-step--active');
    });

    var nextIdx = findNextPrimaryStep(state.currentStepIndex);
    if (nextIdx === -1) return;

    showStep(nextIdx);
  }

  /* ------------------------------------------------------------------ */
  /*  Navigation — back                                                  */
  /* ------------------------------------------------------------------ */
  function goBack() {
    dom.section.querySelectorAll('[js-quiz-transition]').forEach(function (t) {
        t.classList.remove('quiz-step--active');
    });

    if (state.history.length === 0) return;
    var prevIndex = state.history.pop();
    showStep(prevIndex);
    restoreAnswer(state.steps[prevIndex]);
  }

  /* ------------------------------------------------------------------ */
  /*  Answer save / restore                                              */
  /* ------------------------------------------------------------------ */
  function saveAnswer(step) {
    if (step.type === 'form') {
      var input = step.el.querySelector('[js-quiz-form-input]');
      if (!input) return;
      var val = input.value.trim();
      state.answers[step.blockId] = { value: val };

      if (step.inputType === 'text') {
        state.userName = val;
        applyPersonalization();
      } else if (step.inputType === 'number') {
        state.userAge = val;
      } else if (step.inputType === 'email') {
        state.userEmail = val;
      }
    } else if (step.type === 'question') {
      var selected = getSelectedAnswers(step);
      state.answers[step.blockId] = { selected: selected };
    }
  }

  function restoreAnswer(step) {
    if (step.type === 'form') {
      var saved = state.answers[step.blockId];
      var input = step.el.querySelector('[js-quiz-form-input]');
      if (saved && input) {
        input.value = saved.value;
        validateFormStep(step);
      }
    } else if (step.type === 'question') {
      var savedQ = state.answers[step.blockId];
      if (!savedQ) return;
      var answerEls = step.el.querySelectorAll('[js-quiz-answer]');
      answerEls.forEach(function (el) {
        var aId = el.dataset.answerId;
        var inp = el.querySelector('[js-answer-input]');
        if (inp) inp.checked = savedQ.selected.indexOf(aId) >= 0;
      });
      validateQuestionStep(step);
    }
  }

  function getSelectedAnswers(step) {
    var selected = [];
    var answerEls = step.el.querySelectorAll('[js-quiz-answer]');
    answerEls.forEach(function (el) {
      var inp = el.querySelector('[js-answer-input]');
      if (inp && inp.checked) {
        selected.push(el.dataset.answerId);
      }
    });
    return selected;
  }

  /* ------------------------------------------------------------------ */
  /*  Personalization — replace {{name}} tokens                          */
  /* ------------------------------------------------------------------ */
  function applyPersonalization() {
    var name = state.userName || '';
    dom.section.querySelectorAll('[js-quiz-personalizable]').forEach(function (el) {
      if (!el.dataset.originalHtml) {
        el.dataset.originalHtml = el.innerHTML;
      }
      el.innerHTML = el.dataset.originalHtml.replace(/\[name\]/g, name);
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Validation                                                         */
  /* ------------------------------------------------------------------ */
  function validateFormStep(step) {
    var input = step.el.querySelector('[js-quiz-form-input]');
    if (!input) return;

    var val = input.value.trim();
    var btn = step.el.querySelector('[js-quiz-next-btn]') || step.el.querySelector('[js-quiz-submit-btn]');
    var errorEl = step.el.querySelector('[js-quiz-error]');
    var messageEl = step.el.querySelector('[js-quiz-form-message]');

    if (input.type === 'email') {
      var isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
      if (val.length === 0) {
        // Empty — hide both
        if (errorEl) errorEl.style.display = 'none';
        if (messageEl) messageEl.style.display = 'none';
        toggleButton(btn, false);
      } else if (!isValid) {
        if (errorEl) errorEl.style.display = 'block';
        if (messageEl) messageEl.style.display = 'none';
        toggleButton(btn, false);
      } else {
        if (errorEl) errorEl.style.display = 'none';
        if (messageEl) messageEl.style.display = 'block';
        toggleButton(btn, true);
      }
    } else if (input.type === 'number') {
      var num = parseInt(val, 10);
      toggleButton(btn, val.length > 0 && !isNaN(num) && num > 0 && num < 150);
    } else {
      // text
      toggleButton(btn, val.length > 0);
    }
  }

  function validateQuestionStep(step) {
    if (step.selectionType === 'checkbox') {
      var selected = getSelectedAnswers(step);
      var btn = step.el.querySelector('[js-quiz-next-btn]');
      toggleButton(btn, selected.length > 0);
    }
    // radio: no button needed, auto-advances
  }

  function toggleButton(btn, enabled) {
    if (!btn) return;
    if (enabled) {
      btn.classList.remove('disabled');
    } else {
      btn.classList.add('disabled');
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Product scoring                                                    */
  /* ------------------------------------------------------------------ */
  function computeProductScores() {
    var productMap = {};

    Object.keys(state.answers).forEach(function (blockId) {
      var answer = state.answers[blockId];
      if (!answer.selected) return; // skip form answers

      answer.selected.forEach(function (answerId) {
        var answerEl = dom.section.querySelector('[js-quiz-answer][data-answer-id="' + answerId + '"]');
        if (!answerEl) return;

        var productEls = answerEl.querySelectorAll('[js-quiz-product]');
        productEls.forEach(function (pEl) {
          var productId = pEl.dataset.productId;
          var productScore = parseInt(pEl.dataset.productScore, 10) || 0;
          if (!productId) return;

          if (!productMap[productId]) {
            productMap[productId] = { productId: productId, productTotalScore: 0, featureMap: {} };
          }
          productMap[productId].productTotalScore += productScore;

          var featureEls = pEl.querySelectorAll('[js-quiz-feature]');
          featureEls.forEach(function (fEl) {
            var featureHandle = fEl.dataset.featureHandle;
            var featureText = fEl.dataset.featureText;
            var featureScore = parseInt(fEl.dataset.featureScore, 10) || 0;
            if (!featureHandle) return;

            var fMap = productMap[productId].featureMap;
            if (!fMap[featureHandle]) {
              fMap[featureHandle] = { featureHandle: featureHandle, featureText: featureText, featureTotalScore: 0 };
            }
            fMap[featureHandle].featureTotalScore += featureScore;
          });
        });
      });
    });

    var relatedProducts = Object.keys(productMap).map(function (id) {
      var product = productMap[id];
      var features = Object.keys(product.featureMap).map(function (h) { return product.featureMap[h]; });
      features.sort(function (a, b) { return b.featureTotalScore - a.featureTotalScore; });
      return { productId: product.productId, productTotalScore: product.productTotalScore, features: features };
    });
    relatedProducts.sort(function (a, b) { return b.productTotalScore - a.productTotalScore; });

    return relatedProducts;
  }

  function storeResults(products) {
    var results = {
      relatedProducts: products,
      timestamp: Date.now()
    };
    try {
      sessionStorage.setItem('quiz-results', JSON.stringify(results));
    } catch (e) {
      // sessionStorage unavailable
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Event binding                                                      */
  /* ------------------------------------------------------------------ */
  function bindEvents() {
    // Back button
    if (dom.backBtn) {
      dom.backBtn.addEventListener('click', function () {
        goBack();
      });
    }

    // Bind per-step events
    state.steps.forEach(function (step, idx) {
      if (step.type === 'form') {
        bindFormEvents(step);
      } else if (step.type === 'question') {
        bindQuestionEvents(step);

        step.shopifyBlock.querySelectorAll('[js-quiz-transition]').forEach(function (transitionEl) {
          bindTransitionEvents(transitionEl);
        });
        
      }
      // final: no user interaction needed
    });
  }

  function bindFormEvents(step) {
    var input = step.el.querySelector('[js-quiz-form-input]');
    var nextBtn = step.el.querySelector('[js-quiz-next-btn]');
    var submitBtn = step.el.querySelector('[js-quiz-submit-btn]');

    if (input) {
      input.addEventListener('input', function () {
        validateFormStep(step);
      });
      // Enter key advances
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = nextBtn || submitBtn;
          if (btn && !btn.classList.contains('disabled')) {
            btn.click();
          }
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (nextBtn.classList.contains('disabled')) return;
        goForward();
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (submitBtn.classList.contains('disabled')) return;
        goForward();
      });
    }
  }

  function bindQuestionEvents(step) {
    var answerEls = step.el.querySelectorAll('[js-quiz-answer]');

    answerEls.forEach(function (aEl) {
      aEl.addEventListener('change', function (e) {
        if (step.selectionType === 'radio') {
          const quizTransition = aEl.closest('.shopify-block').querySelector('[js-quiz-transition]');

          if(quizTransition) {
            setTimeout(function () {
            dom.section.querySelectorAll('[js-quiz-transition]').forEach(function (t) {
              t.classList.remove('quiz-step--active');
            });

            quizTransition.classList.add('quiz-step--active');
            step.shopifyBlock.classList.add('quiz-step--transition-host');
            }, 300);

            if(state.history.indexOf(state.currentStepIndex) === -1) {
              state.history.push(state.currentStepIndex);
            }

          } else {
            setTimeout(function () {
              goForward();
            }, 300);
          }
        } else {
          validateQuestionStep(step);
        }
      });
    });

    // Checkbox Weiter button
    if (step.selectionType === 'checkbox') {
      var btn = step.el.querySelector('[js-quiz-next-btn]');
      if (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('disabled')) return;
          goForward();
        });
      }
    }
  }

  function bindTransitionEvents(el) {
    var btn = el?.querySelector('[js-quiz-next-btn]');
    if (btn) {
      btn.addEventListener('click', function () {
        goForwardFromTransition();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Final step — loading + redirect                                    */
  /* ------------------------------------------------------------------ */
  function handleFinalStep() {
    var products = computeProductScores();
    console.log({ products })
    storeResults(products);

    // Full progress
    if (dom.progressText) dom.progressText.textContent = '100%';
    if (dom.progressBar) dom.progressBar.style.width = '100%';

    getRelatedProductsAndShow();

    setTimeout(function () {
      document.querySelector('[js-quiz-section]').style.display = 'none';
    }, 1000)

    addUrlParam();

  }

  function addUrlParam() {
    const urlObj = new URL(`${window.location.origin}${window.location.pathname}`);
    urlObj.searchParams.set('result', 'true');
    const updatedUrl = urlObj.toString();
    window.history.replaceState({ path: updatedUrl }, '', updatedUrl);
  }

  function submitEmailToNewsletter() {
    const form = document.querySelector('#quiz-subscribe-form');
    if (!form) return;
    var originalAction = form.action;
    form.removeAttribute('action');
    form.onsubmit = null;
    form.querySelector('[js-quiz-submit-btn]').addEventListener('click', async function(event) {
      event.preventDefault();
      try {
        const formData = new FormData(form);
        const response = await fetch(originalAction, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'text/html'
          }
        });

        await response.text(); 
 
      } catch (error) {
        console.error('Error submitting newsletter form:', error);
      } finally {}
    });

  }

  /* ------------------------------------------------------------------ */
  /*  Shopify theme editor support                                       */
  /* ------------------------------------------------------------------ */
  function bindEditorEvents() {
    if (!(window.Shopify && Shopify.designMode)) return;

    document.addEventListener('shopify:block:select', function (e) {
      var blockId = e.detail.blockId;
      for (var i = 0; i < state.steps.length; i++) {
        if (state.steps[i].blockId === blockId) {
          showStep(i);
          return;
        }
      }
    });

    document.addEventListener('shopify:section:load', function () {
      init();
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Watch for final step activation                                    */
  /* ------------------------------------------------------------------ */
  function watchCurrentStep() {
    // Override showStep to detect final
    var originalShowStep = showStep;
    showStep = function (index) {
      originalShowStep(index);
      var step = state.steps[index];
      if (step && step.type === 'final') {
        handleFinalStep();
      }
    };
  }

  function openCartDrawer() {
    let target = document.querySelector('[data-js-cart-count]');
    if (!target) return;

    let observer = new MutationObserver(function(mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'characterData' || mutations[i].type === 'childList') {
          let cartIcon = document.querySelector('[data-js-cart-icon]');
          if (cartIcon) cartIcon.click();
          break;
        }
      }
    });

    observer.observe(target, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function getRelatedProductsAndShow() {
    const relatedProducts = JSON.parse(sessionStorage.getItem('quiz-results'))?.relatedProducts || [];

    console.log({ relatedProducts})

    if(relatedProducts.length && window.location.search.includes('result=true')) {
        document.querySelector('[js-quiz-section]').style.display = 'none';
    }

    document.querySelectorAll(`[js-quiz-related-product]`).forEach(function(el) {
      el.classList.add('hidden');
      el?.querySelector('[js-quiz-related-product-variant-id]')?.setAttribute('disabled', 'disabled');
    });

    relatedProducts.forEach((relatedProduct, index) => {
      if(index < 4) {
        const mainRsultRelatedProductTag = document.querySelector(`[js-quiz-main-result] [js-quiz-related-product][data-product-id="${relatedProduct.productId}"]`);
        if(mainRsultRelatedProductTag) {
          mainRsultRelatedProductTag?.classList.remove('hidden');
          mainRsultRelatedProductTag.style.order = index;
          mainRsultRelatedProductTag.querySelectorAll('[js-quiz-feature-list]').forEach(function(featureListEl) {
            featureListEl.innerHTML = '';
            relatedProduct.features.forEach((feature, featureIndex) => {
              console.log({ featureIndex })
              if(featureIndex >= 1) return; // only one base on features score
              var li = document.createElement('li');
              var p = document.createElement('p');
              p.className = 'paragraph-xxs';
              p.textContent = feature.featureText;
              li.appendChild(p);
              featureListEl.appendChild(li);
            });
          })
          mainRsultRelatedProductTag.querySelector('[js-quiz-related-product-variant-id]')?.removeAttribute('disabled');
        }
      } else {
        const accordionResultRelatedProductTag = document.querySelector(`[js-quiz-accordion-result] [js-quiz-related-product][data-product-id="${relatedProduct.productId}"]`);
        if(accordionResultRelatedProductTag) { 
          accordionResultRelatedProductTag?.classList.remove('hidden');
          accordionResultRelatedProductTag.style.order = index;
          accordionResultRelatedProductTag.querySelectorAll('[js-quiz-feature-list]').forEach(function(featureListEl) {
            featureListEl.innerHTML = '';
            relatedProduct.features.forEach((feature, featureIndex) => {
              console.log({ featureIndex })
              if(featureIndex >= 1) return; // only one base on features score
              var li = document.createElement('li');
              var p = document.createElement('p');
              p.className = 'paragraph-xxs';
              p.textContent = feature.featureText;
              li.appendChild(p);
              featureListEl.appendChild(li);
            });
          })
        };
        if(index >= 8) return;
      } 
    })

  }


  function relatedProductsIntoCart(){
    document.querySelector('#quiz-multiple-products-atc-form').addEventListener('submit', function(e) {
      const submitButton = e.currentTarget.querySelector('[data-add-to-cart]');
      submitButton.classList.add('btn-loading');
      e.preventDefault();
      const formData = new FormData(this);
      fetch('/cart/add', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        console.log({ response })
        if (!response.ok) throw new Error('Add to cart failed');
        document.dispatchEvent(new CustomEvent('quizATCForm:init'));
      })
      .catch(err => {
        console.error(err);
      })
      .finally(()=> {
        submitButton.classList.remove('btn-loading');
      })
    });
  }

  function updateUserName() {
    const userNameInput = document.querySelector('[js-quiz-username-input]');
    if(userNameInput) {
      const parent = userNameInput.closest('[js-quiz-step]');
      const userNameDisplay = parent.querySelector('[js-quiz-username-wrapper]');
      const userNameDefaultLabel = parent.querySelector('[js-quiz-personalizable]');
      if(userNameDisplay) {
        userNameInput.addEventListener('input', function() {
          const value = userNameInput.value;
          if(value) {
            userNameDisplay.classList.remove('hide');
            userNameDefaultLabel.classList.add('hide');
            userNameDisplay.querySelector('em').textContent = value;
          } else {
            userNameDisplay.classList.add('hide');
            userNameDefaultLabel.classList.remove('hide');
          }
        })
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Init                                                               */
  /* ------------------------------------------------------------------ */
  function init() {
    if (!cacheDom()) return;

    buildSteps();
    initQuizAnswerInputs();
    watchCurrentStep();
    bindEvents();
    bindEditorEvents();
    // submitEmailToNewsletter();
    openCartDrawer();
    getRelatedProductsAndShow();
    relatedProductsIntoCart();
    updateUserName();

    // Show first step
    if (state.steps.length > 0) {
      showStep(0);
    }

    // Apply personalization if name already exists (e.g. back navigation in editor)
    if (state.userName) {
      applyPersonalization();
    }

    
  }

  /* ------------------------------------------------------------------ */
  /*  Boot                                                               */
  /* ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
